import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=51ee5a0f&scoped=true&"
import script from "./Tags.vue?vue&type=script&lang=js&"
export * from "./Tags.vue?vue&type=script&lang=js&"
import style0 from "./Tags.vue?vue&type=style&index=0&id=51ee5a0f&prod&scoped=true&lang=scss&"
import style1 from "./Tags.vue?vue&type=style&index=1&id=51ee5a0f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee5a0f",
  null
  
)

export default component.exports